import { render, staticRenderFns } from "./MapLayerSwitcher.vue?vue&type=template&id=3afc7e8f&scoped=true"
import script from "./MapLayerSwitcher.vue?vue&type=script&lang=js"
export * from "./MapLayerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./MapLayerSwitcher.vue?vue&type=style&index=0&id=3afc7e8f&prod&scoped=true&lang=css"
import style1 from "./MapLayerSwitcher.vue?vue&type=style&index=1&id=3afc7e8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc7e8f",
  null
  
)

export default component.exports